import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { z } from "zod";

import { Spinner } from "../../components";
import { createUser, getUsersList } from "../../../config/redux/actions/admin";
import { formatErrorMessage } from "../../../helpers/helpers";
import { ROLE_LIST } from "../../../constants";
import { setShowRegistrationModal } from "../../../config/redux/slice/adminSlice";

const schema = z.object({
    user_role: z.number().min(0),
    first_name: z.string(),
    middle_name: z.string().optional(),
    last_name: z.string(),
    email: z.string().email(),
});

const CreateNewUser = () => {
    const dispatch = useDispatch();

    const { isLoading, errorMessage } = useSelector((state) => state.admin);
    const { formState, register, handleSubmit } = useForm({ resolver: zodResolver(schema), mode: 'all' });

    const onSubmit = async (data) => {
        try {
            const result = await dispatch(createUser(data)).unwrap();
            toast.success(result.message);
            
            dispatch(setShowRegistrationModal(false));
            await dispatch(getUsersList());
        } catch (error) {
            toast.error(formatErrorMessage(error));
        }
    };

    return ( 
        <form onSubmit={handleSubmit(onSubmit)}>
            <h2 className="mb-4">Create New User</h2>

            <div className="container-fluid p-0">
                <div className="row">
                    <div className="form-group col mb-4">
                        <label htmlFor='first_name'>First Name</label>
                        
                        <input 
                            type="text" 
                            className="form-control input-lg" 
                            placeholder="Enter First Name"
                            {...register("first_name")} 
                        />
                        
                        {formState.errors.first_name && (
                            <div className="text-danger small mt-1">
                                {formState.errors.first_name.message}
                            </div>
                        )}
                    </div> 
                    
                    <div className="form-group col mb-4">
                        <label htmlFor='middle_name'>Middle Name</label>
                        
                        <input 
                            type="text" 
                            className="form-control input-lg" 
                            placeholder="Enter Middle Name (Optional)"
                            {...register("middle_name")} 
                        />
                        
                        {formState.errors.middle_name && (
                            <div className="text-danger small mt-1">
                                {formState.errors.middle_name.message}
                            </div>
                        )}
                    </div> 
                    
                    <div className="form-group col mb-4">
                        <label htmlFor='last_name'>Last Name</label>
                        
                        <input 
                            type="text" 
                            className="form-control input-lg" 
                            placeholder="Enter Last Name"
                            {...register("last_name")} 
                        />
                        
                        {formState.errors.last_name && (
                            <div className="text-danger small mt-1">
                                {formState.errors.last_name.message}
                            </div>
                        )}
                    </div> 
                </div>
                
                <div className="form-group mb-4">
                    <label htmlFor='email'>Email</label>
                    
                    <input 
                        type="text" 
                        className="form-control input-lg" 
                        placeholder="Enter Email"
                        {...register("email")} 
                    />
                    
                    {formState.errors.email && (
                        <div className="text-danger small mt-1">
                            {formState.errors.email.message}
                        </div>
                    )}
                </div> 

                <div className="form-group mb-4">
                    <label htmlFor="user_role">User Role</label>
                    
                    <select id="user_role" className="form-control input-lg" placeholder="Select Role" {...register("user_role", { valueAsNumber: true })}>
                        <option value="">Select a role</option>
                        {ROLE_LIST.map((role) => <option key={role.id} value={role.id}>{role.name}</option>)}
                    </select>

                    {formState.errors.role && <div className="alert alert-danger" role="alert">{formState.errors.role.message}</div>}
                </div>

                {errorMessage && (
                    <div className="mb-4 w-100">
                        <div className="alert alert-danger" role="alert">
                            {errorMessage}
                        </div>
                    </div>
                )}
            </div>

            {isLoading ? <Spinner /> : <button type="submit" className="btn btn-danger" disabled={!formState.isValid}>Save Changes</button>}
        </form>
    );
};

 
export default CreateNewUser;